// @flow
import {
	FormControl,
	FormControlLabel,
	Checkbox as MuCheckbox,
	Typography, FormGroup, FormHelperText,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import findNestedValue from '@shared/utils/findNestedValue';
import HelperText from '@shared/components/helperText';
import type {checkboxType} from "@shared/model/components";


function Checkbox({
	label,
	name,
	control,
	errors,
	defaultValue = false,
	comment,
	color,
	size,
	...checkboxProps
}: checkboxType): React$Node {
	return (
		<Controller
			name={name}
			defaultValue={defaultValue}
			control={control}
			render={({ field }) => {
				const foundError = findNestedValue(errors, name);
				return (
					<FormControl error={Boolean(foundError)}>
						<FormGroup>
							<FormControlLabel
								{...checkboxProps}
								label={
									<Typography color={foundError ? 'error' : 'inherit'}>
										{label}
									</Typography>
								}
								control={
									<MuCheckbox color={color}
										size={size}
										sx={{ color: foundError ? 'error.main' : 'inherit' }}
										checked={field.value}
										{...field}
									/>
								}
							/>
							<FormHelperText>
								<HelperText message={foundError?.message || comment} />
							</FormHelperText>
						</FormGroup>
					</FormControl>
				);
			}
			}
		/>
	);
}

export default Checkbox;
